import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useLang, ui } from '../i18n/LanguageContext';
import { categories, contactInfo } from '../mock/data';

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#161514] text-white/80">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <p className="font-serif text-xl text-white leading-none">Centre d’expertise</p>
          <p className="eyebrow text-champagne mt-1">Familiale</p>
          <p className="text-sm mt-5 leading-relaxed text-white/60 max-w-xs">{t(ui.footer.tagline)}</p>
        </div>

        <div>
          <p className="eyebrow text-white/50 mb-5">{t(ui.footer.quickLinks)}</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-champagne transition-colors">{t(ui.nav.home)}</Link></li>
            <li><Link to="/a-propos" className="hover:text-champagne transition-colors">{t(ui.nav.about)}</Link></li>
            <li><Link to="/services" className="hover:text-champagne transition-colors">{t(ui.nav.services)}</Link></li>
            <li><Link to="/equipe" className="hover:text-champagne transition-colors">{t(ui.nav.team)}</Link></li>
            <li><Link to="/contact" className="hover:text-champagne transition-colors">{t(ui.nav.contact)}</Link></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-white/50 mb-5">{t(ui.footer.servicesTitle)}</p>
          <ul className="space-y-3 text-sm">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/services?cat=${c.slug}`} className="hover:text-champagne transition-colors">{t(c.short)}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow text-white/50 mb-5">{t(ui.footer.contactTitle)}</p>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3"><MapPin size={17} className="text-champagne shrink-0 mt-0.5" /><span className="whitespace-pre-line text-white/60">{contactInfo.address}</span></li>
            <li className="flex gap-3"><Phone size={17} className="text-champagne shrink-0" /><a href={`tel:${contactInfo.phone}`} className="hover:text-champagne transition-colors">{contactInfo.phone}</a></li>
            <li className="flex gap-3"><Mail size={17} className="text-champagne shrink-0" /><a href={`mailto:${contactInfo.email}`} className="hover:text-champagne transition-colors">{contactInfo.email}</a></li>
          </ul>
          {contactInfo.isPlaceholder && (
            <p className="text-[11px] text-white/30 mt-3 italic">* {t(ui.footer.placeholderNote)}</p>
          )}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Centre d’expertise familiale. {t(ui.footer.rights)}</p>
          <Link to="/confidentialite" className="hover:text-champagne transition-colors">{t(ui.footer.privacy)}</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
